import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TeamProvider } from './contexts/TeamContext';
import { Toaster } from './components/ui/sonner';
import './App.css';
import './index.css';

// Pages
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import TeamSelection from './pages/TeamSelection';
import CreateTeam from './pages/CreateTeam';
import Medical from './pages/Medical';
import Financial from './pages/Financial';
import Legal from './pages/Legal';
import Household from './pages/Household';
import Caregiving from './pages/Caregiving';
import EndOfLife from './pages/EndOfLife';
import Memorial from './pages/Memorial';
import Gratitude from './pages/Gratitude';
import Providers from './pages/Providers';
import Documents from './pages/Documents';
import Calendar from './pages/Calendar';
import Analytics from './pages/Analytics';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import Tasks from './pages/Tasks';
import AboutUs from './pages/AboutUs';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/about" element={<AboutUs />} />
      
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <TeamProvider>
            <Dashboard />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/teams" element={
        <ProtectedRoute>
          <TeamProvider>
            <TeamSelection />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/teams/create" element={
        <ProtectedRoute>
          <CreateTeam />
        </ProtectedRoute>
      } />
      
      <Route path="/medical" element={
        <ProtectedRoute>
          <TeamProvider>
            <Medical />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/financial" element={
        <ProtectedRoute>
          <TeamProvider>
            <Financial />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/legal" element={
        <ProtectedRoute>
          <TeamProvider>
            <Legal />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/household" element={
        <ProtectedRoute>
          <TeamProvider>
            <Household />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/caregiving" element={
        <ProtectedRoute>
          <TeamProvider>
            <Caregiving />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/end-of-life" element={
        <ProtectedRoute>
          <TeamProvider>
            <EndOfLife />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/memorial" element={
        <ProtectedRoute>
          <TeamProvider>
            <Memorial />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/gratitude" element={
        <ProtectedRoute>
          <TeamProvider>
            <Gratitude />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/providers" element={
        <ProtectedRoute>
          <TeamProvider>
            <Providers />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/documents" element={
        <ProtectedRoute>
          <TeamProvider>
            <Documents />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/tasks" element={
        <ProtectedRoute>
          <TeamProvider>
            <Tasks />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/calendar" element={
        <ProtectedRoute>
          <TeamProvider>
            <Calendar />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/analytics" element={
        <ProtectedRoute>
          <TeamProvider>
            <Analytics />
          </TeamProvider>
        </ProtectedRoute>
      } />
      
      <Route path="/subscription" element={
        <ProtectedRoute>
          <Subscription />
        </ProtectedRoute>
      } />
      
      <Route path="/subscription/success" element={
        <ProtectedRoute>
          <SubscriptionSuccess />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;